export const COMPETENCIES_FIELD = 'competencies'
